import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Inscripcion from "../pages/inscripcion/page";
import Confirmacion from "../pages/confirmacion/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/inscripcion",
    element: <Inscripcion />,
  },
  {
    path: "/confirmacion",
    element: <Confirmacion />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
